/**
 * File: upcoming-events.js
 *
 * Import and initialize functions for Upcoming Events page
 */

 export default {
  upcomingEvents: document.querySelector('.div-upcoming-events'),
  init() {
    if (this.upcomingEvents) {
      this.render();
    }
  },
  render() {
    [...this.upcomingEvents.querySelectorAll('.event')].forEach(el => {
      el.addEventListener('click', () => el.querySelector('.div-title a').click());
    });
  },
};
